export default class TopNav {
	constructor() {
		this.hamburgerMenu = document.querySelector('.hamburger-menu');
		this.mobileNavPanel = document.querySelector('.nav-links-group.mobile');
		this.closeMenuButton = document.querySelector('.close-menu');
		this.overlay = document.querySelector('.overlay');
		this.body = document.querySelector('body');

		this.activateMenu();
	}

	activateMenu() {
		this.hamburgerMenu.addEventListener('click', () => {
			this.handleMenu();
		})

		this.closeMenuButton.addEventListener('click', () => {
			this.handleMenu();
		})
	}

	handleMenu() {
		if (this.hamburgerMenu.classList.contains('open')) {
			this.closeMenu();
			this.overlay.classList.remove('active');
			this.body.style.overflow = 'auto';
		} else {
			this.openMenu();
			this.overlay.classList.add('active');
			this.body.style.overflow = 'hidden';
		}
	}

	openMenu() {
		this.hamburgerMenu.classList.add('open');
		this.mobileNavPanel.classList.add('open');
	}

	closeMenu() {
		this.hamburgerMenu.classList.remove('open');
		this.mobileNavPanel.classList.remove('open');
	}
}

